import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { TestsPage } from "./pages/TestsPage";
import { TestEditorPage } from "./pages/TestEditorPage";
import { AssignmentsPage } from "./pages/AssignmentsPage";
import { SubmissionsOverviewPage } from "./pages/SubmissionsOverviewPage";
import { SubmissionGradingPage } from "./pages/SubmissionGradingPage";
import { StudentDashboardPage } from "./pages/StudentDashboardPage";
import { StudentTestPage } from "./pages/StudentTestPage";
import { StudentResultsPage } from "./pages/StudentResultsPage";
import { StudentResultDetailPage } from "./pages/StudentResultDetailPage";
import { AdminLayout } from "./components/AdminLayout";
import { StudentLayout } from "./components/StudentLayout";
import { RequireAdmin } from "./auth/RequireAdmin";
import { RequireStudent } from "./auth/RequireStudent";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      >
        <Route index element={<AdminDashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="tests" element={<TestsPage />} />
        <Route path="tests/:testId" element={<TestEditorPage />} />
        <Route
          path="tests/:testId/assignments"
          element={<AssignmentsPage />}
        />
        <Route
          path="tests/:testId/submissions"
          element={<SubmissionsOverviewPage />}
        />
        <Route
          path="submissions/:submissionId"
          element={<SubmissionGradingPage />}
        />
      </Route>
      <Route
        path="/student"
        element={
          <RequireStudent>
            <StudentLayout />
          </RequireStudent>
        }
      >
        <Route index element={<StudentDashboardPage />} />
        <Route path="tests/:testId" element={<StudentTestPage />} />
        <Route path="results" element={<StudentResultsPage />} />
        <Route
          path="results/:submissionId"
          element={<StudentResultDetailPage />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
